module.exports = function(app) {
	app.controller("pages.article", ["brand", "$scope", "$state", "aemContent", "$window",
		function(brand, $scope, $state, aemContent, $window) {
			$scope.backAction = function() {
				$window.history.back();
			};

			$scope.backText = "< Back";
			$scope.headings = "Loading";

            var updateBackButton = function(isClose) {
                if (!isClose) {
                    $scope.backText = "< Back";
                } else {
                    $scope.backText = "Close";
                    $scope.backAction = function() {
                        $window.close();
                    };
                }
            };

            var _ERROR_PAGE_ID = "MBR_ARTICLE_VIEWER_ERROR_MSG";

			// if ($state.params.id) {
			if (window.location.search) {
				// Create a list of content IDs.
				var contentIDs = {
					"MBR_ARTICLE_VIEWER_ERROR_MSG": "MBR_ARTICLE_VIEWER_ERROR_MSG"
				};
				contentIDs[$state.params.id] = $state.params.id;
				contentIDs[window.location.search.substr(1)] = window.location.search.substr(1);

				// Call contentInfo to retreive the content.
				aemContent.getQualifiedContent(window.location.search.substr(1)).then(function (response) {
					// For each item in the response array, attempt to parse JSON.
					// responses.forEach(function (theResponse) {
					// 	var theValue = theResponse["value"];
					// 	try {
					// 		theValue = JSON.parse(theValue);
					// 	} catch (error) {
					// 		theValue = {}
					// 	}

					// 	if (theResponse["name"] === _ERROR_PAGE_ID) {
					// 		content["error"] = theValue;
					// 	} else { // If the item isn't the error page, it must be the requested article.
					// 		content["article"] = theValue;
					// 	}
					// });

					var content = {};
					try {
						content.article = JSON.parse(response);
					} catch (error) {
					}

					// Ensure that the requested content exists and has the necessary properties of a BlueCore Article.
					if (content.article
						&& content.article["title"]
						&& content.article["content"]) {
						$scope.headings = content.article["title"];
						$scope.content= content.article["content"];
                    	updateBackButton(content.article.closeButton);
					} else {
						// Else, display the error page.
						$scope.headings = content["error"]["title"];
						$scope.content = content["error"]["content"];
					}
				}, function (error) {
					// If contentInfo fails, display static text. 
					$scope.headings = "Article Not Found";
					$scope.content = "<p>The article you requested could not be found.</p>";
				});
			}
		}
	]);
	return [
		{
			state: "customArticle",
			appConfigMaintenanceApp: 'LANDING',
			appConfigMaintenanceKey: 'ARTICLE_MAINTENANCE',
			url: "/article",
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/detail.html'],
					controller: "pages.article"
				},
				"content@customArticle": {
					template:   '<article class="custom-article" data-ng-bind-html="content"></article>',
					controller: "pages.article"
				}
			},
			resolve: {
				"redirectUser": function ($q, $location, $window) {
					if ($location.$$url.match(/^\/article\/?$/)) {
						$window.location = "/home/";
						return $q.reject();
					}
				}
			}
		},
		{
			state: "customArticle.id",
			appConfigMaintenanceApp: 'LANDING',
			appConfigMaintenanceKey: 'ARTICLE_MAINTENANCE',
			url: "/:id",
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/detail.html'],
					controller: "pages.article"
				},
				"content@customArticle.id": {
					template:   '<article class="custom-article" data-ng-bind-html="content"></article>',
					controller: "pages.article"
				}
			}
		},
		{
			state: "customClientArticleViewerV2",
			appConfigMaintenanceApp: 'LANDING',
			appConfigMaintenanceKey: 'CUSTOMCLIENTARTICLE_MAINTENANCE',
			url: "/customClientArticleV2",
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/detail.html'],
					controller: "pages.article"
				},
				"content@customClientArticleViewerV2": {
					template:   "<div data-custom-client-article='viewer' ></div>"
				}
			}
		},
		{
			state: "customClientArticleViewer",
			appConfigMaintenanceApp: 'LANDING',
			appConfigMaintenanceKey: 'CUSTOMCLIENTARTICLE_MAINTENANCE',
			url: "/custom-client-article/:id",
			views: {
				'body@': {
					template: bootstrap.templates["page-templates/categoryCustom.html"],
					controller: "pages.article"
				},
				"content@customClientArticleViewer": {
					template:   "<article data-custom-client-article='categoryViewer' article-side-bar='sidebar'></article>"
				}
			}
		}
	];

};